import "./Header.css";

function Header() {
    return (
        <header>
            <img src="/assets/logo_esma.png" alt="logo" id="logo" />
        </header>
    )
}

export default Header;
